var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductQuickView',{attrs:{"showModal":_vm.showModal,"productSku":_vm.productSku,"modalName":"addToShoppingList"},on:{"close-modal":_vm.closeModal}})}
var staticRenderFns = []

export { render, staticRenderFns }